import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawLessonSparkFilledIcon from "./RawLessonSparkFilledIcon.svg.jsx";
import type { IconProps } from "@/components/Icon/Icon";

const LessonSparkFilledIcon = forwardRef<
  SVGSVGElement,
  Omit<IconProps, "SvgComponent">
>((props, ref) => {
  return (
    <Icon
      ref={ref}
      SvgComponent={RawLessonSparkFilledIcon}
      // The SVGR build strips the viewBox; without it the 32-unit artwork is
      // clipped when consumers size the icon below 32px (e.g. the 24px filter
      // checkbox). Callers may still override it via props.
      viewBox="0 0 32 32"
      {...props}
    />
  );
});

LessonSparkFilledIcon.displayName = "LessonSparkFilledIcon";

export default LessonSparkFilledIcon;
